export default __webpack_public_path__ + "static/media/image13.7af4e04a.jpg";